import { CircularSpinner } from '@festina-life/ui/feedback'
import { withSuspense } from '@festina-life/ui/libs'

import type { DownloadButtonProps } from '../../types'
import { CommonDownloadControls } from './CommonDownloadControls'
import { ExportLayerAllConfigurationButton } from './ExportLayerAllConfigurationButton'

const DownloadLayerConfigurationInternal = ({
  branchKey,
}: DownloadButtonProps) => (
  <div className="flex flex-col gap-2 text-left">
    <CommonDownloadControls
      branchKey={branchKey}
      isLayerSelectorVisible
      isSquashVisible={false}
    >
      {({
        shouldIncludeExtrinsicParameterValues,
        shouldIncludeBaseBranch,
        shouldExcludeParameterValues,
        layer,
        block,
        shouldIncludeBaseLayers: shouldIncludeLowerLayers,
        shouldIncludeBaseBlocks: shouldIncludeLowerBlocks,
      }) => (
        <ExportLayerAllConfigurationButton
          layer={layer}
          block={block}
          branchKey={branchKey}
          shouldIncludeExtrinsicParameterValues={
            shouldIncludeExtrinsicParameterValues
          }
          shouldIncludeBaseLayers={shouldIncludeLowerLayers}
          shouldIncludeBaseBranch={shouldIncludeBaseBranch}
          shouldExcludeParameterValues={shouldExcludeParameterValues}
          shouldIncludeBaseBlocks={shouldIncludeLowerBlocks}
        />
      )}
    </CommonDownloadControls>
  </div>
)

export const DownloadLayerConfiguration = withSuspense(
  DownloadLayerConfigurationInternal,
  { fallback: <CircularSpinner className="mx-auto my-2 size-8" /> },
)
